module.exports = __webpack_public_path__ + "static/media/accommodation.41aabc56.svg";